module.exports = __webpack_public_path__ + "img/shishipeixun.5abde896.png";